import { Skademeldingstype } from '../../types/generated-types';

export const getSkadedetaljerUrl = (folgSkadeUrl: string, skadenummer: string | undefined): string => {
    if (skadenummer && skadenummer.includes('.')) {
        const [forsikringsnummer, lopenummer] = skadenummer.split('.');

        return `${folgSkadeUrl}/#/detaljer/${forsikringsnummer}/${lopenummer}`;
    }
    return undefined;
};

export const skadetypeHasMultipleUndertegnereForSigneringsoppdrag = (
    skadetype: Skademeldingstype | undefined,
    isBMKunde: boolean,
): boolean => {
    switch (skadetype) {
        case Skademeldingstype.PersonskadeBarneOgUngdomsforsikring:
            return true;
        case Skademeldingstype.PersonskadeUlykke:
            if (isBMKunde) return false;
            return true;
        default:
            return false;
    }
};

export const skadetypeHasSingleUndertegnerForSigneringsoppdrag = (
    skadetype: Skademeldingstype | undefined,
): boolean => {
    switch (skadetype) {
        case Skademeldingstype.PersonskadeKritiskSykdom:
        case Skademeldingstype.PersonskadeArbeidsuforhet:
            return true;
        default:
            return false;
    }
};
